import { BCP47, formatAmountByLocale } from '@alk/numbers';

export const formatPointsByLocaleNoTruncate = (locale: BCP47) => (value: number): string => {
    const [ , digits ] = value.toString().split('.');
    const nbDigits = digits?.length ?? 0;

    return formatAmountByLocale(locale)(nbDigits)(nbDigits)(value);
};
